/**
 * What the smith asks for (ADR 0013): three materials per biome, in the
 * rarities of the equipment, so their slot in the bag says at a glance how
 * hard they were to come by. The common one falls from the biome's ordinary
 * monsters, the rare one from the guardians of its places of interest, the
 * epic relic from its zone boss.
 *
 * Never bound, always stackable: they are what players trade. Validated by
 * `ItemTemplateSchema` with the rest, in `items.ts`; `upgrades.ts` checks that
 * every biome has its three.
 */
export const UPGRADE_MATERIAL_RARITIES = ['common', 'rare', 'epic'];
export const UPGRADE_MATERIALS = {
    meadow: {
        common: { id: 'flint', name: 'Silex' },
        rare: { id: 'copper-ore', name: 'Minerai de cuivre' },
        epic: { id: 'elder-relic', name: 'Relique des Anciens' },
    },
    forest: {
        common: { id: 'amber-resin', name: 'Résine ambrée' },
        rare: { id: 'iron-ingot', name: 'Lingot de fer' },
        epic: { id: 'sylvan-heart', name: 'Cœur de sylve' },
    },
    swamp: {
        common: { id: 'bog-clay', name: 'Argile des marais' },
        rare: { id: 'mire-pearl', name: 'Perle de vase' },
        epic: { id: 'marsh-eye', name: 'Œil du marais' },
    },
    desert: {
        common: { id: 'glass-sand', name: 'Sable de verre' },
        rare: { id: 'gold-scarab', name: 'Scarabée d’or' },
        epic: { id: 'pharaoh-seal', name: 'Sceau du pharaon' },
    },
    snow: {
        common: { id: 'frost-shard', name: 'Éclat de givre' },
        rare: { id: 'ice-crystal', name: 'Cristal de glace' },
        epic: { id: 'glacier-heart', name: 'Cœur de glacier' },
    },
};
/**
 * Sell price of the common material, per biome: on a par with what the
 * biome's monsters already leave (a rat's pelt 2, a yeti's horn 15). The rare
 * one is worth five commons, the relic five rares.
 */
const COMMON_PRICE = {
    meadow: 2,
    forest: 5,
    swamp: 8,
    desert: 10,
    snow: 15,
};
const PRICE_FACTOR = { common: 1, rare: 5, epic: 25 };
export const UPGRADE_MATERIAL_TEMPLATES = Object.entries(UPGRADE_MATERIALS).flatMap(([biome, materials]) => UPGRADE_MATERIAL_RARITIES.map((rarity) => ({
    id: materials[rarity].id,
    name: materials[rarity].name,
    kind: 'material',
    rarity,
    maxStack: 50,
    icon: `icon.${materials[rarity].id}`,
    sellPrice: COMMON_PRICE[biome] * PRICE_FACTOR[rarity],
})));
//# sourceMappingURL=upgrade-materials.js.map